import { createSlice } from "@reduxjs/toolkit";
import {
  getUsers,
  addNewUser,
  updateUser,
  deleteUser,
  changePassword,
  getUser,
} from "./thunk";

export const initialState = {
  users: [],
  user: null, // For individual user details
  error: {},
  isUserSuccess: false,
  isUserCreated: false,
  isPasswordChanged: false,
  isUserFetched: false, // For `getUser` state
};

const usersSlice = createSlice({
  name: "UsersSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch users
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.users = action.payload; // Assuming `action.payload` contains user data
      state.isUserSuccess = true;
      state.error = null;
    });

    builder.addCase(getUsers.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch users";
      state.isUserSuccess = false;
    });

    // Fetch single user
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.user = action.payload; // Store the single user details
      state.isUserFetched = true;
      state.error = null;
    });

    builder.addCase(getUser.rejected, (state, action) => {
      state.user = null;
      state.isUserFetched = false;
      state.error = action.payload?.error || "Failed to fetch user details";
    });

    // Add new user
    builder.addCase(addNewUser.fulfilled, (state, action) => {
      state.users.push(action.payload); // Add the new user to the list
      state.isUserCreated = true;
      state.error = null;
    });

    builder.addCase(addNewUser.rejected, (state, action) => {
      state.error = action.payload || "Failed to add user";
      state.isUserCreated = false;
    });

    // Update user
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.users = state.users.map((user) =>
        user.id === action.payload.id ? { ...user, ...action.payload } : user
      );
      state.error = null;
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to update user";
    });

    // Delete user
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.users = state.users.filter(
        (user) => user.id !== action.payload.userId
      );
      state.error = null;
    });

    builder.addCase(deleteUser.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete user";
    });

    // Change password
    builder.addCase(changePassword.fulfilled, (state) => {
      state.isPasswordChanged = true;
      state.error = null;
    });

    builder.addCase(changePassword.rejected, (state, action) => {
      state.isPasswordChanged = false;
      state.error = action.payload?.error || "Failed to change password";
    });
  },
});

export default usersSlice.reducer;
